const article = {
  id: 1,
  category: "Droit de l'UE",
  title: "CJUE 2025 : Comment obtenir réparation pour les pratiques anticoncurrentielles ?",
  text: "La Cour de justice de l’UE facilite les actions groupées contre les ententes illicites. Découvrez les implications pour votre entreprise et comment nous pouvons vous accompagner.",
  link: "/articles/droit-ue-reparation-pratiques-anticoncurrentielles-2025",
  date: "Avril 2025",
  highlight: "Une opportunité pour les victimes de récupérer leurs pertes"
};

export default article;
